import { ApolloClient, InMemoryCache, gql, useMutation } from "@apollo/client";
import {USER_REQUEST_PASSWORD} from "../../queries/user-request-password";
import * as React from 'react'

interface Values {
    emailAddress : String;
}

export default function pw_lost_email () {

    const formref = React.useRef<HTMLFormElement>(null);

    const [dorequest, { error: cError, loading: cLoading }] = useMutation(
        USER_REQUEST_PASSWORD
      );

    async function handleSubmit(event) {
        event.preventDefault();
        const formData = new FormData(formref.current);
        const email = String(formData.get('email'));
        const values: Values = {"emailAddress" : email };

        const resp = await dorequest({variables: values });
        if (!resp.errors) {
            alert("Sie erhalten eine E-Mail mit der Anleitung Ihr Passwort neu zu vergeben.")
        }    
    };

    return(  <div className="container-fluid">
        <h2>Passwort vergessen: Geben Sie Ihre E-Mail an</h2>
        <form onSubmit={handleSubmit} ref={formref}>
            <div className="mb-3">    
            <label htmlFor="email" className="form-label-sm">E-Mail mit der Sie registriert sind*</label>   
            <input className="form-control" id="email" name="email"   />
            
            </div>

            <button className="btn btn-primary" type="submit">Absenden</button>
        </form>

    </div>);

}





